import { render, staticRenderFns } from "./TestResults.vue?vue&type=template&id=4a956a4c&"
import script from "./TestResults.vue?vue&type=script&lang=js&"
export * from "./TestResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports